<template>
  <section class="sme-container__info">
    <template>
      <div
        v-for="(item,index) in kycInfo"
        :key="index"
        class="box">
        <div
          class="table"
          :class="item.class" >
          <div class="th font-14" >{{item.title}}</div>
          <div
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.noShow"
            :key="sumIndex"
            class="tr"
            :class="{
              'flex-start': sumItem.showValue2
            }"
          >
            <span class="fw-600">{{ sumItem.name }}</span>
            <span
              v-if="sumItem.isMoney"
              v-copy="sumItem.value"
            >
              {{sumItem.value|formatMoney(2,true)}}
            </span>
            <span
              v-else-if="sumItem.isBlue"
              class="blue pointer"
              @click="openFile(sumItem.value)"
            >
              {{sumItem.value?'Download':'-'}}
            </span>
            <span
              v-else
              v-copy="sumItem.value"
            >
              {{sumItem.value}}
            </span>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'

export default {
  name: 'indicatioveOriginalInfo',
  mixins: [MixinOptions, MixinFormat, MixinRules],

  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
  },
  computed:{
    kycInfo(){
      let {indicative_pdf_path} = this.formData||{}
      let arr =  [
        {
          title: 'Indicative',
          isBold:true,
          list: [
            {
              name: 'Created Date',
              value: this.formData.created_at,
            },
            {
              name: 'Indicative Premium',
              value: this.formData.indicative_prm,
              // isMoney:this.formData.indicative_prm=='TBC'?false:true
            },
            {
              name: 'Indicative Quotation',
              value: indicative_pdf_path,
              isBlue:true
            },
          ],
        },
        {
          title: 'Applicant Original Contact',
          isBold:true,
          list: [
            {
              name: 'Name',
              value: this.formData.origin_contact_nm,
            },
            {
              name: 'Phone Number',
              value: this.formData.origin_contact_phone,
            }
          ],
        },
      ]
      return arr
    },
  },
  methods:{
    openFile({url}) {
      if(url) {
        window.open(url, '_blank')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../quoting/sme/info";
.flex-start{
  align-items: flex-start !important;
}
.marketing + .marketing{
  margin-top: 10px;
}
.sme-container__info .table .tr span[data-v-6e7dd6b6]:nth-child(2) {
  &.blue{
    color: $blue!important;
  }
}

</style>
